import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
export const Image = styled.img``
